<template>
  <body class="hold-transition login-page">
  <div class="login-box" style="width: 400px !important;">
    <div class="login-logo">
      <img src="/static/img/crp-images/Logo_RCP_Smart_App.png" class="logo-login-signup">
    </div>
    <!-- /.login-logo -->
    <div class="box login-bbox">
      <div class="box-body login-card-body pd-20">
        <p class="login-box-msg login-txt">Admin Login</p>
        <md-field :class="getValidationClass('email')">
          <label class="lable-fileds">Email</label>
          <md-input type="email" v-model="form.email" name="email" id="email" autocomplete="email"/>
          <span class="md-error" v-if="!$v.form.email.required">The email is required</span>
          <span class="md-error" v-if="$v.form.email.required && this.formBackendValidation.email.isError">{{this.formBackendValidation.email.errorMsg}}</span>
        </md-field>
        <md-field :class="getValidationClass('password')">
          <label class="lable-fileds"> Password </label>
          <md-input type="password" v-model="form.password" name="password" id="password" autocomplete="password"/>
          <span class="md-error" v-if="!$v.form.password.required">The password is required</span>
          <span class="md-error" v-if="$v.form.password.required && this.formBackendValidation.password.isError">{{this.formBackendValidation.password.errorMsg}}</span>
        </md-field>
        <md-card-actions class="lg-sp">
          <md-button @click="validateSubmission" class="rgbtnn md-raised md-accent btn-block">Login</md-button>
        </md-card-actions>
        <!-- <p class="mb-0">
          <a href="forgot-password.html"><u>I forgot my password</u></a>
        </p> -->
      </div>
    </div>
  </div>
  </body>
</template>
<script>
  import {required} from 'vuelidate/lib/validators'
  import {validationMixin} from 'vuelidate'
  import Vue from 'vue'
  import api from '../../../api'
  import $ from 'jquery'

  var SyncLoader = require('vue-spinner/src/SyncLoader')

  export default {
    name: 'AdminLoginView',
    mixins: [validationMixin],
    components: {
      'SyncLoader': SyncLoader
    },
    loader: null,
    rememberMe: false,
    newModalLoading: false,
    data: () => ({
      form: {
        email: null,
        password: null
      },
      formBackendValidation: {
        email: {
          isError: false,
          errorMsg: ''
        },
        password: {
          isError: false,
          errorMsg: ''
        }
      }
    }),
    validations: {
      form: {
        email: {required},
        password: {required}
      }
    },
    methods: {
      openScreenLoading() {
        this.loader = this.$loading.show({
          container: this.fullPage ? null : this.$refs.formContainer,
          canCancel: false,
          onCancel: this.onCancel,
          color: '#FECD2F',
          loader: 'dots',
          width: '100px',
          backgroundColor: '#000000',
          opacity: '0.5'
        })
      },
      onCancel() {
        console.log('User cancelled the loader.')
      },
      getValidationClass(fieldName) {
        const field = this.$v.form[fieldName]

        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty
          }
        }
      },
      authDetailsStoreInLocalStorage(data) {
        this.$store.commit('TOGGLE_LOADING')
        if (data) {
          Vue.auth.setToken(data)
          // alert(Vue.auth.getToken())
          // alert(data.access_token)
          this.$router.push(data.redirect)
          this.loader.hide()
        } else {
          this.loader.hide()
        }
      },
      clearNewForm() {
        this.$v.$reset()
        this.form.email = ''
        this.form.password = ''
      },
      validateSubmission() {
        this.$v.$touch()
        if (!this.$v.form.$invalid) {
          this.openScreenLoading()
          this.addNewRecord(this.$v.form.$model)
        }
      },
      addNewRecord(data) {
        // alert(this.csrf)
        this.newModalLoading = true
        api.request('post', '/admin/login', data)
          .then(response => {
            var ref = this
            this.$v.$reset()
            if (response.status === 200) {
              if (response.data.error) {
                $.each(response.data.error, function(key, valueObj) {
                  if (ref.formBackendValidation.hasOwnProperty(key.toString())) {
                    ref.formBackendValidation[key.toString()].isError = true
                    ref.formBackendValidation[key.toString()].errorMsg = valueObj[0]
                    $('#' + key.toString()).parent().addClass('md-invalid')
                  }
                })
                ref.loader.hide()
                ref.newModalLoading = false
                ref.form.password = ''
              } else if (response.data.hasOwnProperty('result') && response.data.result.hasOwnProperty('access_token') && response.data.result.access_token) {
                ref.newModalLoading = false
                ref.loader.hide()
                ref.clearNewForm()
                response.data.result.redirect = '/'
                ref.authDetailsStoreInLocalStorage(response.data.result)
                window.location.reload()
              }
            } else {
              ref.newModalLoading = false
              // eslint-disable-next-line no-undef
              toast.fire({icon: 'error', title: 'Something wrong'})
              ref.loader.hide()
            }
            // if (response.hasOwnProperty('data') && response.data.hasOwnProperty('result') && response.data.result && ((response.data.result.hasOwnProperty('status') && response.data.result.status === 'success') || response.data.result.id)) {
            //   this.newModalLoading = false
            //   this.clearNewForm()
            //   response.data.result.redirect = '/admin/overview'
            //
            //   this.authDetailsStoreInLocalStorage(response.data.result)
            //   // eslint-disable-next-line no-undef
            //   toast.fire({icon: 'success', title: 'well come'})
            //   window.location.reload()
            // } else if (response.hasOwnProperty('data') && response.data.hasOwnProperty('result') && response.data.result && response.data.result.hasOwnProperty('status') && response.data.result.status === 'error') {
            //   // form errorsback end
            //   this.loader.hide()
            // } else {
            //   this.loader.hide()
            //   this.newModalLoading = false
            //   // eslint-disable-next-line no-undef
            //   toast.fire({icon: 'error', title: 'Something wrong'})
            // }
          }).catch(error => {
            this.loader.hide()
            this.newModalLoading = false
            this.$store.commit('TOGGLE_LOADING')
          // eslint-disable-next-line no-undef
            toast.fire({icon: 'error', title: error})
            this.response = 'Server appears to be offline'
            this.toggleLoading()
          })
      }
    }
  }
</script>
<style>
  .logo-login-signup {
    max-width: 35% !important;
  }
</style>



// WEBPACK FOOTER //
// AdminLoginView.vue?653b64fb